import React, { useEffect, useRef, useState } from 'react';

const CorpVideo = () => {
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const videoRef = useRef(null);

    const videoId = 'rB95ju_J4NA';
    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/0.jpg`;
    const iframeSrc = `https://www.youtube.com/embed/${videoId}`;

    useEffect(() => {
        const currentVideoRef = videoRef.current;
    
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIframeLoaded(true);
                        observer.unobserve(currentVideoRef);
                    }
                });
            },
            {
                rootMargin: '100px',
            }
        );
    
        if (currentVideoRef) observer.observe(currentVideoRef);
    
        return () => {
            if (currentVideoRef) observer.unobserve(currentVideoRef);
        };
    }, []);

    return (
        <div className="bg-light-blue py-12">
            <div className="container mx-auto">
                <div className="grid grid-cols-12 gap-4 items-center">
                    <div className="col-start-2 lg:col-start-2 col-span-10 lg:col-span-4">
                        <div className="aspect-w-16 aspect-h-9 mt-8 h-64 rounded-xl overflow-hidden" ref={videoRef}>
                            {!iframeLoaded ? (
                                <button
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setIframeLoaded(true)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') setIframeLoaded(true);
                                    }}
                                    tabIndex={0}
                                >
                                    <img
                                        src={thumbnailUrl}
                                        alt="Play Video"
                                    />
                                </button>
                            ) : (
                                <iframe
                                    title="Holborn Assets Group"
                                    src={iframeSrc}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen={true}
                                    className="w-full h-full"
                                ></iframe>
                            )}
                        </div>
                    </div>
                    <div className="col-start-2 lg:col-start-7 col-span-10 lg:col-span-4 mt-8">
                        <p>We are part of the wider Holborn Assets Group, a leading, award-winning financial advisory company established in 1998 in the United Arab Emirates (UAE).</p>
                        <p>Holborn Assets has a global footprint with 18 offices across 13 countries. Across our international offices, we support over 20,000 clients, managing more than $2 billion of assets.</p>
                        <p className="text-lg font-semibold">Wherever life takes you, our team can help ensure your money is in the right place at the right time.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CorpVideo;
